module.exports = __webpack_public_path__ + "static/img/0000镇赉叫号2.9166574.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/0000镇赉叫号2.jpg
// module id = GtXr
// module chunks = 0